export default "__VITE_ASSET__UYnZ_MPC__"